var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('audience-tree-level',{attrs:{"data":_vm.data,"selected":_vm.value,"parents-of-selected":_vm.parentsOfSelected}})}
var staticRenderFns = []

export { render, staticRenderFns }